import { useNavigate } from "flemo";
import { HeartIcon } from "lucide-react";
import { toast } from "sonner";

import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";

export const EMPTY_FAVORITES_TOAST_ID = "flashcards-empty-favorites";

type FavoriteCardProps = {
  isPlus: boolean;
  favoriteCount: number;
  onPaywallOpen: () => void;
};

const FavoriteCard = ({ isPlus, favoriteCount, onPaywallOpen }: FavoriteCardProps) => {
  const { push } = useNavigate();

  const handleFavoriteClick = () => {
    if (favoriteCount === 0) {
      toast.message("즐겨찾기한 단어가 없어요", {
        id: EMPTY_FAVORITES_TOAST_ID,
        description: "카드 학습에서 하트를 눌러 즐겨찾기해 보세요!",
        position: "top-center",
      });
      return;
    }

    if (!isPlus) {
      onPaywallOpen();
      return;
    }

    push("/flashcards/:id", { id: "favorites" });
  };

  return (
    <div className="flex gap-3 px-5">
      <Card
        className="relative flex-1 bg-secondary-background p-4 text-left active:scale-95 transition-transform flex flex-col gap-3 cursor-pointer overflow-hidden"
        onClick={handleFavoriteClick}
      >
        <div className="flex items-center gap-2">
          <HeartIcon className="w-8 h-8 text-secondary fill-secondary" />

          {!isPlus && (
            <Badge
              variant="outline"
              className="bg-primary/15 text-primary border-none px-2 py-0.5 text-xs font-semibold rounded-md"
            >
              Plus
            </Badge>
          )}
        </div>

        <div className="flex flex-col gap-1">
          <p className="font-bold text-foreground text-base">My favorites</p>
          <p className="text-muted-foreground text-xs mt-0.5">{favoriteCount} cards</p>
        </div>
      </Card>
    </div>
  );
};

export default FavoriteCard;
